function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _classCallCheck(a, n) { if (!(a instanceof n))
    throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
} }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e))
    return e; if (void 0 !== e)
    throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
}
catch (t) { } return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e)
    throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Box, Typography, Container, Stack, useTheme } from '@mui/material';
import { AuthorizationAPI } from '../apis';
import Cookies from 'js-cookie';
import ErrorIcon from '../../public/ErrorIcon.svg';
import { getEmailFromSession } from '@/utils';
import { constants } from '@/constants';
import { useThemeDetails } from './ThemeDetailsContext';
export function ErrorPage() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, message = _ref.message;
    var theme = useTheme();
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            minHeight: '780px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.background["default"]
        },
        "data-testid": "error-page"
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(Container, {
        maxWidth: "lg",
        sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: (stateImages === null || stateImages === void 0 ? void 0 : stateImages.Error) || ErrorIcon,
        alt: "Error Illustration",
        sx: {
            width: stateImages !== null && stateImages !== void 0 && stateImages.Error ? 180 : 120,
            height: stateImages !== null && stateImages !== void 0 && stateImages.Error ? 180 : 120,
            mb: 4,
            display: 'block'
        }
    }), /*#__PURE__*/ React.createElement(Stack, {
        spacing: 1,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        fontWeight: 600,
        color: "text.primary",
        textAlign: "center"
    }, message || constants.error_page_title), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.primary",
        textAlign: "center"
    }, constants.error_page_description(getEmailFromSession()))))));
}
var ErrorBoundary = /*#__PURE__*/ function (_React$Component) {
    function ErrorBoundary(props) {
        var _this;
        _classCallCheck(this, ErrorBoundary);
        _this = _callSuper(this, ErrorBoundary, [props]);
        // Define a state variable to track whether is an error or not
        _defineProperty(_this, "isLoggingError", false);
        _defineProperty(_this, "handleErrorEvent", function (e) {
            var _e$error;
            if (_this.isLoggingError)
                return;
            _this.isLoggingError = true;
            AuthorizationAPI.logError({
                msg: "".concat(Cookies.get('ui_trace_id'), "-").concat(((_e$error = e.error) === null || _e$error === void 0 ? void 0 : _e$error.stack) || e.message)
            }).then(console.log)["catch"](function (err) {
                return console.error('[ErrorBoundary] logError failed (error event):', err);
            })["finally"](function () {
                _this.isLoggingError = false;
            });
        });
        _defineProperty(_this, "handleUnhandledRejection", function (e) {
            var _e$reason$statusCode, _e$reason, _e$reason2, _e$reason3;
            // Skip rate-limit errors — logging them would only make the 429 worse
            var statusCode = (_e$reason$statusCode = (_e$reason = e.reason) === null || _e$reason === void 0 ? void 0 : _e$reason.statusCode) !== null && _e$reason$statusCode !== void 0 ? _e$reason$statusCode : (_e$reason2 = e.reason) === null || _e$reason2 === void 0 || (_e$reason2 = _e$reason2.response) === null || _e$reason2 === void 0 ? void 0 : _e$reason2.status;
            if (statusCode === 429)
                return;
            if (_this.isLoggingError)
                return;
            _this.isLoggingError = true;
            AuthorizationAPI.logError({
                msg: "".concat(Cookies.get('ui_trace_id'), "-").concat(((_e$reason3 = e.reason) === null || _e$reason3 === void 0 ? void 0 : _e$reason3.stack) || String(e.reason))
            }).then(console.log)["catch"](function (err) {
                return console.error('[ErrorBoundary] logError failed (unhandledrejection):', err);
            })["finally"](function () {
                _this.isLoggingError = false;
            });
        });
        _this.state = {
            hasError: false,
            errorMsg: ''
        };
        return _this;
    }
    _inherits(ErrorBoundary, _React$Component);
    return _createClass(ErrorBoundary, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                globalThis.addEventListener('error', this.handleErrorEvent);
                globalThis.addEventListener('unhandledrejection', this.handleUnhandledRejection);
            }
        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                globalThis.removeEventListener('error', this.handleErrorEvent);
                globalThis.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
            }
        }, {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                // Log error details
                console.error('ErrorBoundary caught an error:', error.message);
                // You can use your own error logging service here
                this.setState({
                    errorMsg: error.message
                });
                AuthorizationAPI.logError({
                    msg: "".concat(Cookies.get('ui_trace_id'), "-").concat(error.stack)
                }).then(function (response) {
                    console.log(response);
                })["catch"](function (err) {
                    return console.error('[ErrorBoundary] logError failed (componentDidCatch):', err);
                });
            }
        }, {
            key: "render",
            value: function render() {
                // Check if the error is thrown
                if (this.state.hasError) {
                    // Render the ErrorPage component as fallback UI
                    return /*#__PURE__*/ React.createElement(ErrorPage, null);
                }
                // Return children components in case of no error
                return this.props.children;
            }
        }], [{
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                // Update state so the next render will show the fallback UI
                return {
                    hasError: true
                };
            }
        }]);
}(React.Component);
export default ErrorBoundary;
